import { UseMutationOptions, useQueryClient } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidatePlansQueries } from '../../utils/query-invalidation';

type DeletePlanInput = {
  planId: string;
};

export function useDeletePlan(options?: UseMutationOptions<void, unknown, DeletePlanInput>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ planId }) => {
      const api = getPrivateApi();
      await api.deletePlan({
        planId,
      });
    },
    ...options,
    onSuccess: async () => {
      await invalidatePlansQueries(queryClient);
    },
  });
}
